import CompactSelect from './CompactSelect.js';
export { default } from './CompactSelect.js';
import 'react/jsx-runtime';
import 'react-select';
//# sourceMappingURL=index.js.map
